<nav class="bg-white border-b border-[var(--border-default)] h-16 flex items-center">
  <div class="flex items-center justify-between w-full px-4">
    <!-- Izquierda: Logo + breadcrumb -->
    <div class="flex items-center gap-4">
      <a class="flex items-center gap-3 px-2 shrink-0 pl-11" routerLink="/knowledge-base">
        <img src="veflo-vault-logo.svg" [alt]="appName" class="h-[47px] w-auto object-contain block select-none" />
      </a>

      <!-- <div class="card flex justify-center">
        <p-breadcrumb class="max-w-full pl-12" [model]="items()" [home]="home">
          <ng-template pTemplate="item" let-item let-last="last">
            <ng-container *ngIf="item.routerLink; else nonlink">
              <a class="inline-flex items-center gap-2 hover:text-primary" [routerLink]="item.routerLink">
                <i *ngIf="item.icon" [class]="item.icon"></i>
                <span>{{ item.label }}</span>
              </a>
            </ng-container>
            <ng-template #nonlink>
              <span class="inline-flex items-center gap-2" [class.font-medium]="last">
                <i *ngIf="item.icon" [class]="item.icon"></i>
                <span>{{ item.label }}</span>
              </span>
            </ng-template>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div> -->
    </div>

    <div class="flex items-center gap-4">
      <!-- mr-4 restaura los 32px hasta el bloque de usuario. Antes los producía
           el <notification-modal> hermano, que cerrado no ocupa ancho pero sí
           consumía un hueco de `gap-4`; ahora la medida es explícita. -->
      <notification-bell class="mr-4"></notification-bell>
      <div
        class="flex items-center justify-between rounded-[4px] px-4
              bg-[var(--bg-surface-hover)] py-2 min-w-[220px] cursor-pointer"
        (click)="toggleUserMenu($event)"
      >
      <div *ngIf="authService.userLogin() as user">
        <div class="flex items-center gap-3">
          <div class="w-8 h-8 bg-sky-100 rounded-full flex items-center justify-center border border-[var(--border-default)]">
            <span class="text-[var(--cta-text-on-soft-primary)] font-medium qbrain-text-sm">{{initials(user.name)}}</span>
          </div>
          
          <div class="hidden sm:flex flex-col leading-tight">
            <span class="text-sm font-medium qbrain-text-primary">{{user.name}}</span>
            <span class="qbrain-text-sm qbrain-text-tertiary">{{ UserRole[user.role] | translate }}</span>
          </div>
        <img src="assets/icons/Arrow_Down.svg" [alt]="'common.actions.openMenu' | translate" />
      </div>
      </div>
      </div>
      <user-menu
        [(visible)]="userMenuOpen"
      >
      </user-menu>

    </div>
  </div>
</nav>